// 个人中心
export default [
	{
		path: '/user',
		redirect: '/user/profile',
		name: 'User',
		component: () => import('@/views/user/index'),
		meta: { title: '个人中心' },
		children: [
			{
				path: 'profile',
				name: 'UserProfile',
				component: () => import('@/views/user/profile'),
				meta: { title: '个人资料' }
			},
			{
				path: 'message',
				name: 'UserMessage',
				component: () => import('@/views/user/message'),
				meta: { title: '消息通知' }
			},
			{
				path: 'common',
				redirect: '/user/common/export',
				name: 'UserCommon',
				component: () => import('@/views/user/common/index.vue'),
				meta: { title: '常用功能' },
				children: [
					{
						path: 'export',
						name: 'UserExport',
						component: () => import('@/views/user/common/export'),
						meta: { title: '导出记录' }
					},
					{
						path: 'company',
						name: 'UserCompany',
						component: () => import('@/views/user/common/company'),
						meta: { title: '我的企业' }
					},
					{
						path: 'company/auth',
						name: 'CompanyAuth',
						component: () => import('@/views/user/common/companyAuth'),
						meta: { title: '企业认证' }
					},
					{
						path: 'collection',
						name: 'UserCollection',
						component: () => import('@/views/user/common/collection'),
						meta: { title: '我的收藏' }
					},
					{
						path: 'subscription',
						name: 'UserSubscription',
						component: () => import('@/views/user/common/subscription'),
						meta: { title: '我的订阅' }
					}
				]
			},
			{
				path: 'monitor',
				redirect: '/monitor/list',
				name: 'UserMonitor',
				component: () => import('@/views/user/monitor/index.vue'),
				meta: { title: '监控预警' },
				children: [
					{
						path: 'list',
						name: 'MonitorList',
						component: () => import('@/views/user/monitor/list'),
						meta: { title: '监控列表' }
					},
					{
						path: 'message-settings',
						name: 'MonitorMessageSettings',
						component: () => import('@/views/user/monitor/message-settings'),
						meta: { title: '监控消息设置' }
					},
					{
						path: 'settings',
						name: 'MonitorSettings',
						component: () => import('@/views/user/monitor/settings'),
						meta: { title: '监控设置' }
					}
				]
			},
			{
				path: 'market',
				redirect: '/user/market/order',
				name: 'UserMarket',
				component: () => import('@/views/user/market/index'),
				meta: { title: '会员管理' },
				children: [
					{
						path: 'order',
						name: 'OrderList',
						component: () => import('@/views/user/market/order'),
						meta: { title: '会员订单' }
					},
					{
						path: 'order/select',
						name: 'OrderSelect',
						component: () => import('@/views/user/market/orderSelect'),
						meta: { title: '申请开票' }
					},
					{
						path: 'invoice',
						name: 'InvoiceList',
						component: () => import('@/views/user/market/invoice'),
						meta: { title: '我的发票' }
					},
					{
						path: 'coupon',
						name: 'CouponList',
						component: () => import('@/views/user/market/coupon'),
						meta: { title: '我的优惠券' }
					},
					{
						path: 'my-member-benefits',
						name: 'MyMemberBenefits',
						component: () => import('@/views/user/market/memberBenefits'),
						meta: { title: '会员权益' }
					},
					{
						path: 'my-member-benefits-record',
						name: 'MyMemberBenefitsRecord',
						component: () => import('@/views/user/market/memberBenefitsRecord'),
						meta: { title: '会员权益使用记录' }
					}
				]
			},
			{
				path: 'shoppmanag',
				redirect: '/user/shoppmanag/shoppOrder',
				name: 'ShoppManag',
				component: () => import('@/views/user/shoppmanag/index'),
				meta: { title: '购物管理' },
				children: [
					{
						path: 'shoppOrder',
						name: 'ShoppOrder',
						component: () => import('@/views/user/shoppmanag/shoppOrder'),
						meta: { title: '购物订单' }
					}
					// {
					// 	path: 'order/select',
					// 	name: 'OrderSelect',
					// 	component: () => import('@/views/user/shoppmanag/shoppOrderSelect'),
					// 	meta: { title: '购物车' }
					// }
				]
			}
		]
	}
]
